import { ISelectOption } from '@constants/entities/ui';
import useCurrentAsset from '@hooks/useCurrentAsset';
import useProjectId from '@hooks/useProjectId';
import { useGetBusinessAttributesQuery } from '@store/services/nodes';
import { useMemo } from 'react';

const useBusinessAttributesOptions = () => {
  const projectId = useProjectId(true);
  const currentAsset = useCurrentAsset();

  const domainIds =
    currentAsset.dto?.domainNodes?.map(({ domain_id }) => domain_id) ?? [];

  const { data, isLoading, isFetching } = useGetBusinessAttributesQuery({
    projectId,
    domainIds,
  });

  const options: ISelectOption[] = useMemo(() => {
    return (data ?? []).map(({ id, name }) => ({ value: id, label: name }));
  }, [data]);

  return {
    options,
    isLoading: isLoading || isFetching,
  };
};

export default useBusinessAttributesOptions;
